import { createFileRoute } from '@tanstack/react-router';
import { PaySlipLayoutRegistryPage } from './-components/PaySlipLayoutRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout/settings/pay-slips/')({
  component: PaySlipLayoutRegistryPage
});